// @ts-nocheck
import * as React from "react";
import SubscriptionIcons from "../../assets/icons/svgIcons/subscriptionIcons";
import DeviceContext from "../service/indentifyDevice";
import { Idevice } from "../types/device";
import EdModal from "../generic/edModal";
import EdButton from "../generic/edButton";
import LoginService from "../service/login/loginService";
import bStrg from "../service/storageHelper";
import { ICOMPersonalDetails, IPersonalDetails } from "../types/components/login/userDetails";
import { saveLeadInfo_v1 } from "../service/postLogin/leadAPIService";
import { getLeadMasterDetails } from "../service/postLogin/leadAPIService";
import ee from "../utils/eventEmitter";
import { useQuery } from "../service/urlHelper";
import hero_image from "../../assets/images/infinity-plan-hero.png";
import PageFooterDock from "./infinityPlan/pageFooterDock";
import PlansPricingDesk from "./infinityPlan/IPDeskComp/PlansPricingDesk";
import PlansPricingMob from "./infinityPlan/IPMobComp/PlansPricingMob";
import IPlan from "./infinityPlan/IPTypes";
import PlanAllDetailsMob from "./infinityPlan/IPMobComp/PlanAllDetailsMob";
import IPServiceList from "./infinityPlan/IPServiceList";
import * as infinityPlanData from "../../ds/infinityPlan.json";
import GuestLeadForm from "./infinityPlan/guestLeadForm";
import EdelLogo from "../../assets/icons/svgIcons/logo";
import gtmService from "../service/gtmService";

const handleDevice: Idevice = DeviceContext();

if (handleDevice.isDesktop) {
	require("../../assets/scss/components/subscription/infinityPlan.scss");
} else if (handleDevice.isMobile) {
	require("../../assets/scss/components/subscription/infinityPlanMob.scss");
}

export interface IInfinityPlanProps {}

//services offered in infinity plan subscription

function thank_you(): React.ReactElement {
	return (
		<>
			<div className="modal-dialog modal-dialog-centered">
				<div className="modal-content">
					<div className="modal-body">
						<label className="tick_bg">
							<i className="edel-icon-tick"></i>
						</label>
						<p className="message mg-t30">Thank you!</p>
						<p className="sub_msg mg-t10">We’ll be in touch with you shortly</p>
					</div>
				</div>
			</div>
		</>
	);
}
function lead_failure(): React.ReactElement {
	return (
		<>
			<div className="modal-dialog modal-dialog-centered">
				<div className="modal-content">
					<div className="modal-body">
						<p className="message mg-t30">Lead could not be created!</p>
						<p className="sub_msg mg-t10">Email/mobile already available against existing client</p>
					</div>
				</div>
			</div>
		</>
	);
}

function subscribe_dialog(saveLeadCallback: () => void, showModalFunc: (val: boolean) => any): React.ReactElement {
	return (
		<>
			<div className="modal-dialog modal-dialog-centered">
				<div className="modal-content">
					<button
						className="close_link"
						onClick={() => {
							gtmService({
								event: "event Quick_Order",
								category: "Direct MF",
								action: "Pop Up",
								labelUrlR: "close"
							});
							showModalFunc(false);
						}}
					>
						<i className="edel-icon-close"></i>
					</button>
					<div className="modal-body">
						<label className="knot">
							<SubscriptionIcons width="114" height="80" icon="blue_knot" />
						</label>
						<p className="message mg-t25">Subscribe to INFINITY to invest in Direct Mutual Funds</p>
						<p className="sub_msg mg-t20">
							Exclusive benefits on brokerage and other charges of upto <b>₹</b>8 Lakh
						</p>
						<div>
							<button
								onClick={() => {
									gtmService({
										event: "event Quick_Order",
										category: "Direct MF",
										action: "Pop Up",
										labelUrlR: "Know more"
									});
									showModalFunc(false);
								}}
								className="mg-t10 closeModal"
							>
								Know more
							</button>
						</div>
						<EdButton
							btnTyp="primary"
							value="I’m Interested"
							slim
							className="mg-t50"
							onClick={() => {
								gtmService({
									event: "event Quick_Order",
									category: "Direct MF",
									action: "Pop Up",
									labelUrlR: "I'm Interested"
								});
								saveLeadCallback();
							}}
						/>
					</div>
				</div>
			</div>
		</>
	);
}

function GuestFormDialog(): React.ReactElement {
	const { setShowModal } = React.useContext(IPContext);

	return (
		<>
			<div className={"modal-dialog"}>
				<div className={"modal-content"}>
					{DeviceContext().isMobile && (
						<>
							<EdelLogo fill="#003e92" width="115" height="17" viewbox="5 7 115 17" />
							<button
								className="close_link"
								onClick={() => {
									gtmService({
										event: "event Quick_Order",
										category: "Direct MF",
										action: "Pop Up",
										labelUrlR: "close"
									});
									setShowModal(false);
								}}
							>
								<i className="edel-icon-close"></i>
							</button>
						</>
					)}
					<div className="modal-body">
						<p className={"title"}>Please provide your details</p>

						<GuestLeadForm />
					</div>
				</div>
			</div>
		</>
	);
}

type IInfinityPlanContext = {
	dockToBtm: boolean;
	plans: Array<IPlan>;
	selectedPlan: IPlan | null;
	setShowAllPlan: (val: boolean) => any;
	setSelectedPlan: (val: IPlan) => any;
	saveLead: (details?: IPersonalDetails & ICOMPersonalDetails) => any;
	setShowModal: (val: boolean) => any;
	showModalFunc: (res: any) => any;
	showLeadFailureModal: (res: any) => any;
};
export const IPContext = React.createContext<IInfinityPlanContext>({
	dockToBtm: true,
	plans: [],
	selectedPlan: null,
	setShowAllPlan(val) {},
	setSelectedPlan(val) {},
	saveLead() {},
	setShowModal() {},
	showModalFunc() {},
	showLeadFailureModal() {}
});

export function InfinityPlan() {
	//flag to show and hide the subscribe modal
	const [showModal, setShowModal] = React.useState<boolean>(false);
	//flag to show and hide the thank you modal
	const [showTQModal, setShowTQModal] = React.useState<boolean>(false);
	//flag to show and hide the lead failure modal
	const [showLFModal, setShowLFModal] = React.useState<boolean>(false);
	//used to fix the plan table header on scroll
	const [isFixed, setIsFixed] = React.useState<boolean>(false);
	//bottom docker control state
	const [dockToBtm, setDockToBtm] = React.useState<boolean>(true);

	//use to show all plans in mobile
	const [showAllPlan, setShowAllPlan] = React.useState<boolean>(false);

	const [selectedPlan, setSelectedPlan] = React.useState<IPlan | null>(null);

	const query = useQuery();
	const subscribe = query.get("subscribe");
	const source = query.get("source");

	async function saveLead(details?: IPersonalDetails & ICOMPersonalDetails) {
		//contains user profile details such as name, email id, phone number etc.,
		let resp = await getLeadMasterDetails("10");
		let pDetails: IPersonalDetails & ICOMPersonalDetails = bStrg("PersonalDetails") || details;
		if (pDetails) {
			const req = 
			{
				email: pDetails.emailAddressField || pDetails.EMAIL,
				name: pDetails.nameField || pDetails.NAME,
				phone: pDetails.mobileNumberField || pDetails.MOBILENO,
				productId: resp? resp[0].product_code : "",
				categoryId: resp? resp[0].category_code : "",
				subCategoryId: resp? resp[0].subcategory_code : "",
				sourceId: resp? resp[0].source_code : "",
				subSourceId: resp? resp[0].subsource_code: "",
				elliance: false
			};
			window.history.pushState({}, "", window.location.href.split("?")[0]);

			req && saveLeadInfo_v1(saveLeadCallback, req);
		}
	}

	function saveLeadCallback(res: any) {
		if (res.indexOf("Lead Created") >= 0 || res.indexOf("Lead created") >= 0)  {
			setShowModal(false); //hide subscribe window
			showModalFunc(true); //show thank you window
		} else {
			setShowModal(false); //hide subscribe window
			showLeadFailureModal(true); //show lead failure modal
		}
	}

	const showModalFunc = (val: boolean) => {
		setShowTQModal(val);
		const isShowAllPlanActive: boolean = showAllPlan;

		isShowAllPlanActive && setShowAllPlan(false);
		if (val) {
			//hide the popup
			setTimeout(() => {
				setShowTQModal(false);
				isShowAllPlanActive && setShowAllPlan(true);
			}, 5000);
		}
	};
	const showLeadFailureModal = (val: boolean) => {
		setShowLFModal(val);
		const isShowAllPlanActive: boolean = showAllPlan;

		isShowAllPlanActive && setShowAllPlan(false);
		if (val) {
			//hide the popup
			setTimeout(() => {
				setShowLFModal(false);
				isShowAllPlanActive && setShowAllPlan(true);
			}, 5000);
		}
	};

	//on scroll rearrange the menu items in header
	const handleHeader = () => {
		//hide/show the top layer of header if  vertical scroll depth > 50px
		const ele: HTMLElement | null = document.getElementById("infinityPlans"),
			pageEle: HTMLElement | null = document.getElementById("infinityPlanPage"),
			footerEle: HTMLElement | null = document.getElementById("plans_n_pricing_ftr");

		// stick to page on page scroll ends and reachs out footer
		footerEle && pageEle && setDockToBtm(window.scrollY + window.innerHeight - 100 >= pageEle.offsetHeight ? false : true);

		ele && setIsFixed((document.documentElement.scrollTop || document.body.scrollTop) > ele.offsetTop ? true : false);
	};

	React.useEffect(() => {
		!handleDevice.isMobile && window.addEventListener("scroll", handleHeader);
		ee.on("fetchProfile", (res) => {
			//console.log(res);
			subsribeState();
		});
		return () => {
			window.removeEventListener("scroll", handleHeader);
		};
	}, []);
	const subsribeState = () => {
		//if not subscirbed and choosing to subscribe and if logged in

		const isLoggedIn = LoginService.isLoggedIn();
		//flag indentifies whether user subscribed for the plan or not
		const infinityPlanFlag = LoginService.getAccData("accs")?.mfInf;
		if (!infinityPlanFlag && subscribe && isLoggedIn) {
			if (!source) {
				//when user clicked directly on I'm interested button in the footer of the page
				saveLead();
			} else if (source === "EMT" || source === "TX3") {
				//when user redirected/loaded this page from any other platform, show the subscribe dialog
				setShowModal(true);
			}
		} else {
			window.history.pushState({}, "", window.location.href.split("?")[0]);
		}
	};
	React.useEffect(() => {
		subsribeState();
	}, [subscribe]);
	return (
		<section className="infinityPlan" id="infinityPlanPage">
			<div className={"page_header " + (!handleDevice.isMobile ? "mg-b80" : "mg-b60")}>
				<div className="header_content ed_container">
					<div className="left_cont">
						<h1 className="h1_head mg-b10">INFINITY SUBSCRIPTION FEES PROGRAM</h1>
						<p className={"sub_hding " + (!handleDevice.isMobile ? "mg-b20" : "mg-b10")}>
							Infinite Offering, endlessly rewarding experience
						</p>
						<p className="sub_desc">
							This first of its kind plan from Nuvama offers a complete wealth ecosystem which enables traders and investors like you to
							access an inﬁnite array of services, beneﬁts and privileges which deliver an awesome trading and investment experience. The
							offering is inﬁnite. The experience is endlessly rewarding.
						</p>
					</div>
					<div className="hero_image_container">
						<img
							className={"right_image" + (handleDevice.isMobile ? " top_image" : "")}
							src={hero_image}
							alt="INFINITY SUBSCRIPTION FEES PROGRAM"
						></img>
					</div>
				</div>
			</div>
			<IPContext.Provider
				value={{
					dockToBtm,
					plans: infinityPlanData.plans,
					selectedPlan,
					setSelectedPlan,
					setShowAllPlan,
					saveLead,
					setShowModal,
					showModalFunc
				}}
			>
				{/* services offered in infinity plan subscription */}
				<div className="services ed_container">{IPServiceList()}</div>

				{/* Plans & pricing */}
				<div className="plans_pricing_div mg-t70 ed_container">
					<h2 className={"h2_head " + (handleDevice.isMobile ? "mg-b50" : "mg-b40")}>Subscription Program & Pricing</h2>

					{!handleDevice.isMobile && (
						<div id="infinityPlans" className={isFixed ? "fixed_header" : ""}>
							<PlansPricingDesk />
						</div>
					)}
					{handleDevice.isMobile && (
						<div id="infinityPlans">
							<PlansPricingMob />
						</div>
					)}
				</div>

				<div className="TnC ed_container">
					<div className="mg-b95">
						<p className="mg-b10">
							* Minimum brokerage per order of Rs 25 (subject to maximum of 2.5% or maximum slab as per the regulatory guidelines will be
							levied
						</p>
						<p>
							** For Direct MF, Savings as a difference between expense ratio between direct MF and regular MF scheme is assumed at 1.5%.
							<br /> MF growth assumed at 12% CAGR. Beneﬁt over 15 years is annualized
							{handleDevice.isMobile && <br />}
							<a
								href="https://www.edelweiss.in/cas/tnc/tnc-infinity-subscription.html"
								className="ext_link mg-t10"
								target="_blank"
								rel={"noreferrer"}
							>
								Terms and conditions apply
							</a>
						</p>
					</div>
				</div>

				<div className={dockToBtm ? "pd-b70" : ""}>
					{/*{PageFooterDock(saveLead, dockToBtm)}*/}
					<PageFooterDock />
				</div>

				<EdModal
					children={<PlanAllDetailsMob />}
					show={showAllPlan}
					close={() => {
						setShowAllPlan(false);
					}}
					modalClsNm="view_all_plan"
				/>
				<EdModal
					children={thank_you()}
					show={showTQModal}
					close={() => {
						setShowTQModal(false);
					}}
					modalClsNm="infinity_thank_you"
				/>
				<EdModal
					children={lead_failure()}
					show={showLFModal}
					close={() => {
						setShowTQModal(false);
					}}
					modalClsNm="infinity_thank_you"
				/>
				<EdModal
					children={<GuestFormDialog />}
					show={showModal && !LoginService.isLoggedIn()}
					close={() => {
						setShowModal(false);
					}}
					modalClsNm="infinity_guest_form"
				/>
				<EdModal
					children={subscribe_dialog(saveLead, setShowModal)}
					show={showModal && LoginService.isLoggedIn()}
					close={() => {
						setShowModal(false);
					}}
					modalClsNm="infinity_subscribe"
				/>
			</IPContext.Provider>
		</section>
	);
}
